var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6.45331C3.25 5.21067 4.25736 4.20331 5.5 4.20331H18.4985C19.7412 4.20331 20.7485 5.21067 20.7485 6.45331L20.7485 9.20331H3.25V6.45331Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.25 10.7033H20.7485L20.7485 14.5891C20.286 12.7427 18.6156 11.3752 16.6257 11.3752C14.6067 11.3752 12.9165 12.7831 12.4834 14.6706C11.2623 15.2891 10.4258 16.5549 10.4258 18.0175V20.0274C10.4258 20.6298 10.5678 21.199 10.8202 21.7033H5.5C4.25736 21.7033 3.25 20.6959 3.25 19.4533V10.7033Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6257 12.8752C15.1069 12.8752 13.8757 14.1064 13.8757 15.6252V15.7873C12.7749 15.934 11.9258 16.8766 11.9258 18.0175V20.0274C11.9258 21.2701 12.9331 22.2774 14.1758 22.2774H19.0758C20.3184 22.2774 21.3258 21.2701 21.3258 20.0274V18.0175C21.3258 16.8766 20.4766 15.934 19.3757 15.7873V15.6252C19.3757 14.1064 18.1445 12.8752 16.6257 12.8752ZM17.8757 15.6252V15.7675H15.3757V15.6252C15.3757 14.9348 15.9354 14.3752 16.6257 14.3752C17.3161 14.3752 17.8757 14.9348 17.8757 15.6252Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoLock);
export default __webpack_public_path__ + "static/media/DuoLock.176c730fcacbcc1428dd44f963aa993f.svg";
export { ForwardRef as ReactComponent };